import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {

    if (!localStorage.getItem("token")) {
        return < Navigate to="/" />
    } else if (localStorage.getItem("token") === undefined) {
        return < Navigate to="/" />
    }
    return <Outlet/>

}

export default ProtectedRoute